(() => {
  'use strict';
  const isSearchPath = path => /\/search\/?$/.test(path);
  const wordQuery = text => {
    const clean = text.trim();
    // Preserve intentional Shopify search syntax.
    if (!clean || /[:"*()]|\b(?:AND|OR|NOT)\b/.test(clean)) return clean;
    return clean.split(/\s+/).map(word => '"' + word.replace(/\\/g, '\\\\') + '"').join(' ');
  };
  const current = new URL(window.location.href);
  if (isSearchPath(current.pathname)) {
    const query = current.searchParams.get('q') || '';
    const exact = wordQuery(query);
    if (exact !== query && exact) {
      current.searchParams.set('q', exact);
      window.location.replace(current.href);
      return;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isSearchPath(new URL(form.action, location.href).pathname)) return;
    const input = form.elements.namedItem('q');
    if (input instanceof HTMLInputElement) input.value = wordQuery(input.value);
  }, true);
  function prepareSuggestions() {
  const suggestions = document.querySelector('[data-wam-search-suggestions]');
  if (!suggestions || suggestions.dataset.wamSuggestionsReady === 'true') return;
  suggestions.dataset.wamSuggestionsReady = 'true';
  const contextUrl = new URL(location.href);
  const hasFilters = [...contextUrl.searchParams.keys()].some(key => key.startsWith('filter.'));
  const label = suggestions.querySelector('[data-wam-suggestion-label]');
  if (label && hasFilters) label.textContent = 'Try a new search without filters:';
  const query = suggestions.dataset.query;
  if (!query) return;
  const root = (window.theme?.routes?.root_url || '/').replace(/\/?$/, '/');
  const endpoint = new URL(root + 'search/suggest.json', location.origin);
  endpoint.searchParams.set('q', query);
  endpoint.searchParams.set('resources[type]', 'query');
  endpoint.searchParams.set('resources[limit]', '3');
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 6000);
  fetch(endpoint.href, { signal: controller.signal })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const queries = data?.resources?.results?.queries;
      if (!Array.isArray(queries) || !queries.length) return;
      const list = suggestions.querySelector('ul');
      queries.forEach(item => {
        if (typeof item.text !== 'string' || !item.text.trim()) return;
        const target = new URL(contextUrl.href);
        target.searchParams.set('q', wordQuery(item.text));
        target.searchParams.delete('page');
        for (const key of [...target.searchParams.keys()]) {
          if (key.startsWith('filter.')) target.searchParams.delete(key);
        }
        const link = document.createElement('a');
        link.href = target.href;
        link.textContent = item.text;
        link.dataset.testid = 'wam-search-suggestion';
        const li = document.createElement('li');
        li.append(link);
        list.append(li);
      });
      suggestions.hidden = !list.children.length;
    })
    .catch(() => { /* The empty state and catalog links remain available. */ })
    .finally(() => window.clearTimeout(timeout));
  }
  prepareSuggestions();
  document.addEventListener('wam:results-updated', prepareSuggestions);
})();
